import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunicationService } from 'src/app/services/communication.service';
import { UrlSegments } from '../jurisdiction.constants';
import { CopyApplicationDataRequest, GetApplicationDataResponse } from './copy-application-data.domain';
import { map } from 'rxjs/operators';

@Injectable()
export class CopyApplicationDataService {
  constructor(private communicationService: CommunicationService) {}

  getExistingApplicationIds(skApplicationType: string): Observable<GetApplicationDataResponse[]> {
    return this.communicationService
      .getData(`${UrlSegments.CopyApplication}/${skApplicationType}`)
      .pipe(map((response: any[]) => response.map(m => ({ applicationId: m.application_id, externalId: m.external_id }))));
  }

  copyApplicationData(requestData: CopyApplicationDataRequest): Observable<number> {
    return this.communicationService.postData(`${UrlSegments.CopyApplication}`, requestData);
  }
}
